<!--
* @Description:相关调研6
* @Date: 2024-01-20 12:21:01
-->
<template>
  <div
    class="patient-sex"
    ref="TaskRef"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }"
  >
    <div class="contnet" ref="ContentRef">
      <div class="contnet-warp">
        <div class="contnet-warp-icon">
          <div class="dashed"></div>
          <svg6></svg6>
          <div class="base-svg">
            <div><baseSvg></baseSvg></div>
          </div>
          <div class="contnet-warp-icon-pint">
            <div
              id="pints"
              v-for="(item, index) in data.tipData"
              class="contnet-warp-icon-pint-item"
              :key="index"
              :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
            >
              <div class="contnet-warp-icon-pint-item-r">
                <div id="lines" class="contnet-warp-icon-pint-line"></div>
                <div class="contnet-warp-icon-pint-dot">
                  <!-- {{ sequence[index] }} -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-warp-text">
          <div
            id="texts"
            class="content-warp-text-item"
            v-for="(item, index) in data.tipData"
            :key="index"
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
          >
            <div class="content-warp-text-item-r">
              <div class="white"></div>
              <div class="bg"></div>
              <div class="inner">
                <div>
                  <div v-for="(citem, cindex) in item" :key="cindex">
                    {{ citem.label }}：{{ citem.value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 项目名称 -->

      <div class="content-name">
        <div>
          <div
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
            v-for="(item, index) in data.projectName"
            :key="index"
          >
            <div class="block-color"></div>
            <!-- <div>{{ sequence[index] }}</div> -->
            <div>{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, defineProps } from 'vue';
import {
  selfAdaption,
  pcModulePatientSex6,
  useDataAssembly
  // sequence
} from './hooks';
import { svg6, baseSvg } from './svg-components/index';
const props = defineProps<{
  tableHeaderList: Array<{ label: Array<string>; prop: string }>;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();
let data = useDataAssembly(props.tableHeaderList, props.tableDataList);
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
  pcModulePatientSex6(TaskRef.value);
});
</script>

<style lang="scss" scoped>
@import './index.scss';
.patient-sex {
  @include patientSex();
  .contnet {
    @include content();
    position: relative;
    .contnet-warp {
      margin: auto;
      margin-top: 47px;
      height: 482px;
      width: 897.32px;
      position: relative;
      .contnet-warp-icon {
        height: 482px;
        width: 897.32px;
        @include alignCenter();
        width: 566.38px;
        height: 202.4px;
        .base-svg {
          width: 235.61px;
          height: 235.61px;
          background-color: var(--theme-color-1, #000);
          border-radius: 50%;
          @include alignCenter();
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .dashed {
          z-index: 1;
          @include alignCenter();
          width: 185.28px;
          height: 185.28px;
          border-radius: 100%;
          border: 2px dashed #fff;
        }
      }
      .contnet-warp-icon-pint {
        width: 100%;
        height: 100%;
        @include alignCenter();
        .contnet-warp-icon-pint-item {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          width: 20px;
          height: 20px;
          background-color: var(--color);
          border-radius: 100%;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          .contnet-warp-icon-pint-item-r {
            position: relative;
            .contnet-warp-icon-pint-line {
              transform-origin: top;
              position: absolute;
              width: $--tipsLine;
              height: 100px;
              background-color: var(--color);
            }
            .contnet-warp-icon-pint-dot {
              position: absolute;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
      .content-warp-text {
        width: 100%;
        height: 100%;
        @include alignCenter();
        .content-warp-text-item {
          position: absolute;
          width: 189.66px;
          height: 117px;
          border-radius: 12px;
        }
        .content-warp-text-item-r {
          position: relative;
          width: 100%;
          height: 100%;
          .white {
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 12px;
            background-color: #fff;
          }
          .bg {
            opacity: $--opacityText;
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 12px;
            background-color: var(--color);
          }
          .inner {
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 12px;
            border: 1px solid var(--color);
            display: flex;
            justify-content: center;
            align-items: center;
            > div {
              @include text();
            }
          }
        }
      }
    }
    .content-name {
      margin-top: 50px;
      height: 100px;
      width: 100%;
      display: flex;
      justify-content: center;
      > div {
        display: flex;
        width: 80%;
        justify-content: center;

        > div {
          margin: 0 10px;
          display: flex;
          width: 100%;
          > div:nth-child(1) {
            margin-right: 5px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 600;
            color: #0f0f0f;
          }
          > div:nth-child(2) {
            @include bottomText();
          }
        }
      }
    }
  }
}
</style>
